import styled from 'styled-components';
import { modalShadow } from '../../themes/shadows';

export const Modal = styled.div`
  cursor: initial;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 99999;
  background-color: rgba(0,0,0, 0.5);
  backdrop-filter: blur(2px);
`;

export const ContainerClose = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  background-color: ${(props) => props.theme.colors.card};
  width: 30%;
  height: 30%;
  overflow-y: auto;
  padding-left: 5.0vw;
  padding-right: 5.0vw;
  padding-top: 2.5vh;
  padding-bottom: 2.5vh;
  border-radius: 10px;
  z-index: 999999;
  box-shadow: ${modalShadow};
  border: 1px solid ${(props) => props.theme.colors.disabled};
`;

export const Text = styled.div`
  display: flex;
  justify-content: center;
  font-weight: 500;
  font-size: 24px;
  color: ${(props) => props.theme.colors.darkerblue};
`;

export const Button = styled.button`
  display: flex;
  width: 40%;
  height: 150%;
  color: ${(props) => props.theme.colors.white};
  text-transform: uppercase;
  border-radius: ${(props) => props.theme.radii.lg};
  border: 1px solid ${(props) => props.color || props.theme.colors.label};
  font-weight: ${(props) => props.theme.fontWeights.bold};
  align-items: center;
  justify-content: center;
  background: ${(props) => props.color || props.theme.colors.label};
  cursor: pointer;
  transition: all ${(props) => props.theme.transitions.base};
  font-size: ${(props) => props.theme.fontSizes.lg};

  :hover {
    background: ${(props) => props.theme.colors.card};
    color: ${(props) => props.color || props.theme.colors.label};
  }

  :focus-visible {
    outline: 2px solid ${(props) => props.theme.colors.focus};
    outline-offset: 2px;
  }
`;

export const Line = styled.div`
  justify-content: center;
  display: flex;
`;


export const ButtonClose = styled.button`
  width: 34px;
  height: 34px;
  border-radius: 8px;
  background: ${(props) => props.theme.colors.disabled};
  color: ${(props) => props.theme.colors.label};
  font-weight: bold;
  font-size: 12px;
  transition: 0.2s all;

  :hover {
    cursor: pointer;
    transform: scale(1.1);
  }
`;

export const Elemento = styled.div`
  position: ${(props) => (props.position ? props.position : '')};
  display: flex;
  flex-direction: ${(props) => (props.direction ? props.direction : 'column')};
  flex-wrap: ${(props) => (props.wrap ? props.wrap : '')};
  margin-bottom: ${(props) => (props.wrap ? props.wrap : '26vh')};
  justify-content: ${(props) => (props.justify ? props.justify : '')};
  align-items: ${(props) => (props.align ? props.align : '')};
  width: ${(props) => (props.width ? props.width : '')};
`;
